<mat-dialog-content>
  <p>{{message}}</p>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <button mat-stroked-button (click)="onDismiss()">Cancel</button>
  <button mat-flat-button color="primary"  (click)="onConfirm()">Confirm</button>
</mat-dialog-actions>
